export function isFindAGymPage(path: string): boolean {
    const findAGymPattern = /^\/find-a-gym\/?$/;
    return findAGymPattern.test(path);
}
